import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loginmain from "./Pages/HGO/Authentication/Loginmain";
import Signupmain from "./Pages/HGO/Authentication/Signupmain";
import SignupHgo from "./Pages/HGO/Authentication/SignupHgo";
import SignupMonazam from "./Pages/HGO/Authentication/SignupMonazam";
import ResetPassword from "./Pages/HGO/Authentication/ResetPassword";
import ResetPassword1 from "./Pages/HGO/Authentication/ResetPassword1";
import IncomingDashboard from "./Pages/HGO/Dashboard/Incoming/Incoming";
import OutgoingDashboard from "./Pages/HGO/Dashboard/Outgoing/Outgoing";
import MerchantDashboard from "./Pages/HGO/Dashboard/Merchant/Merchant";
import MonazamAccountDashboard from "./Pages/HGO/Dashboard/MonazamAccount/MonazamAccount";
import OpapDashboard from "./Pages/HGO/Dashboard/OpapAccount/OpapAccount";
import EhajjDashboard from "./Pages/HGO/Dashboard/EhajjAccountnew/EhajjAccount";
import ErrorPage from "./Pages/HGO/Dashboard/CommonComponents/ErrorPage";
import AccumulativeRequest from "./Pages/HGO/Dashboard/AccumulativeRequest/AccumulativeRequest";
import ReversalAccumulativeRequest from "./Pages/HGO/Dashboard/ReversalAccumulativeRequest/ReversalAccumulativeRequest";
import ReversalIncomingRequest from "./Pages/HGO/Dashboard/ReversalIncomingRequest/ReversalIncomingRequest";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import HgoRequest from "./Pages/HGO/Dashboard/HgoRequst/HgoRequest";
import LoanRequests from "./Pages/HGO/Dashboard/LoanRequests/LoanRequests";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Loginmain />} />
          <Route path="/createaccount" element={<Signupmain />} />
          <Route path="/signuphgo" element={<SignupHgo />} />
          <Route path="/signupmonazam" element={<SignupMonazam />} />
          <Route path="/forgotpassword" element={<ResetPassword />} />
          <Route path="/reset-password/:email" element={<ResetPassword1 />} />
          <Route path="/incoming/:userType" element={<IncomingDashboard />} />
          <Route path="/outgoing/:userType" element={<OutgoingDashboard />} />
          <Route path="/merchant/:userType" element={<MerchantDashboard />} />
          <Route path="/hgorequest/:userType" element={<HgoRequest />} />
          <Route path="/loans/:userType" element={<LoanRequests />} />
          <Route
            path="/monazamaccount/:userType"
            element={<MonazamAccountDashboard />}
          />
          <Route path="/opap/:userType" element={<OpapDashboard />} />
          <Route path="/ehajj/:userType" element={<EhajjDashboard />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnHover
          theme="dark"
        />
      </div>
    </Router>
  );
}

export default App;
